/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {FunctionParameter} from './function-parameter';

export class FunctionParameterData {
  functionParameter: FunctionParameter;
  value: string;
}
